const getDefaultState = () => {
  return {
    businessGuideTour: false,
    ideaPlanTour: false,
    financialPlanTour: false,
    businessPlanTour: false
  }
}

const state = getDefaultState()

const mutations = {
  setCompleted (state, tourName) {
    state[tourName] = true
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
